import { IShoppingCartState } from '@/@types'

const state: IShoppingCartState = {
  shoppingCart: [],
  selectedPlan: {},
  bundleProductHasError: false,
  addOnsCertificationsList: [],
  selectedAddOnsByUser: false,
}

export default state
